import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

type TimeSeriesChartErrorStateProps = {
  message: string;
  isRetrying: boolean;
  onRetry: () => void;
  'data-qa-element-id': string;
};

/**
 * Failed request with a way forward. The central Axios handler already notified the user about
 * the network error, so this only shows where the diagram cannot continue and offers a retry.
 */
export function TimeSeriesChartErrorState({
  message,
  isRetrying,
  onRetry,
  'data-qa-element-id': dataQaElementId,
}: TimeSeriesChartErrorStateProps) {
  const { t } = useTranslation();

  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" disabled={isRetrying} onClick={onRetry}>
          {t('error.dialog.tryAgain')}
        </Button>
      }
      data-qa-element-id={dataQaElementId}
      sx={{ m: 2 }}
    >
      {message}
    </Alert>
  );
}
